import React from 'react';
import {Link} from 'react-router';
import {Button, Dialog } from "@blueprintjs/core";
import classnames from 'classnames';

class DeleteDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false
    }
  }

  toggleDialog() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  okAction() {
    if (typeof this.props.redux != 'undefined') {
      this.props.redux.handleDelete(this.props.deleteId);
      this.setState({
        ...this.state,
        isOpen: false
      });
    }
    if (typeof this.props.onSuccess == 'function') {
      this.setState({
        ...this.state,
        isOpen: false
      });
      this.props.onSuccess();

    }
  }

  render() {
    return (
      <div className="wrap-link-todo">
        <Link className="itt-delete" onClick={this.toggleDialog.bind(this)}>
          {this.props.textHuy === true ? 'Huỷ' : this.props.labelButton}
        </Link>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.toggleDialog.bind(this)}
          title={this.props.title}
          className="reception-dialog delete-dialog"
          >
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">{this.props.content}</p>
          </div>
          <div className="pt-dialog-footer">
            <div className="pt-dialog-footer-actions reception-delete-confirm">
              <Button
                onClick={this.toggleDialog.bind(this)}
                text="Không"
                className="btn-default"
              />
              <Button
                onClick={this.okAction.bind(this)}
                text="Đồng ý"
                className={classnames('btn-green', {'btn-loading': this.props.buttonLoading})}
              />

            </div>
          </div>
        </Dialog>
      </div>

    );
  }
}

DeleteDialog.defaultProps= {
  labelButton: 'Xoá'
}

export default DeleteDialog;



// WEBPACK FOOTER //
// ./src/components/modules/dialog/DeleteDialog.jsx